import { render, staticRenderFns } from "./Carousal.vue?vue&type=template&id=e53b392e&scoped=true&"
import script from "./Carousal.vue?vue&type=script&lang=js&"
export * from "./Carousal.vue?vue&type=script&lang=js&"
import style0 from "./Carousal.vue?vue&type=style&index=0&id=e53b392e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53b392e",
  null
  
)

export default component.exports